import moment from 'moment';
import {
  MY_FILTER,
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 品类筛选器
  GENRETOR as FILTER_GENRE_SELECT,
  TIPICON,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

const isValidDate = (date: moment.Moment) =>
  // 选择范围在今天之前
  date.isSameOrBefore(moment(), 'day');

// 筛选器默认配置
export const FILTER_DEFAULT_LIST_MAP = {
  MY_FILTER: {
    savePopupVisble: 0,
    key: MY_FILTER,
    value: '',
  },
  FILTER_RANGE_TIME: {
    savePopupVisble: 1,
    key: FILTER_RANGE_TIME,
    type: FILTER_RANGE_TIME,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  FILTER_GENRE_SELECT: {
    savePopupVisble: 1,
    key: FILTER_GENRE_SELECT,
  },
  TIPICON: {
    savePopupVisble: 0,
    key: TIPICON,
    visibleinlist: 1,
    content: 'dbi_weixin_filter_info',
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [MY_FILTER]: {
    value: '',
  },
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [FILTER_GENRE_SELECT]: {
    source: 'wechat_minigame',
    mainGenres: [],
    subGenres: [],
    minigame_genre: [],
    overlayClassName: 'weixin-mode',
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  FILTER_DEFAULT_LIST_MAP.MY_FILTER,
  FILTER_DEFAULT_LIST_MAP.FILTER_RANGE_TIME,
  FILTER_DEFAULT_LIST_MAP.FILTER_GENRE_SELECT,
  FILTER_DEFAULT_LIST_MAP.TIPICON,
];

// 微信游戏榜单名组
export const MINI_GAME_RANKING_KEY_LIST = ['wechat_popularity', 'wechat_bestseller', 'wechat_most_played'];
export const MINI_GAME_RANKING_KEY_LIST_DOUYIN = ['douyin_popularity', 'douyin_bestseller', 'douyin_fresh_game'];
export const MINI_GAME_RANKING_KEY_MINIGAME_LIST = ['minigame__wechat_popularity', 'minigame__wechat_bestseller', 'minigame__wechat_most_played'];
export const MINI_GAME_RANKING_KEY_MINIGAME_LIST_DOUYIN = ['minigame__douyin_popularity', 'minigame__douyin_bestseller', 'minigame__douyin_fresh_game'];

// 下钻页对应名称
export const MINI_GAME_RANKING_MORE_TITLE_MAP: Record<string, string> = {
  wechat_popularity: 'dbi_top_rank_wechat_popularity_wechat',
  wechat_bestseller: 'dbi_top_rank_wechat_bestseller_wechat',
  wechat_most_played: 'dbi_top_rank_wechat_most_played_wechat',
  douyin_popularity: 'dbi_top_rank_douyin_popularity_douyin',
  douyin_bestseller: 'dbi_top_rank_douyin_bestseller_douyin',
  douyin_fresh_game: 'dbi_top_rank_douyin_fresh_game_douyin',
};

export const MINI_GAME_RANKING_MORE_TITLE_MAP_DOUYIN: Record<string, string> = {
  douyin_popularity: 'dbi_top_rank_douyin_popularity_douyin',
  douyin_bestseller: 'dbi_top_rank_douyin_bestseller_douyin',
  douyin_fresh_game: 'dbi_top_rank_douyin_fresh_game_douyin',
};

export const MINI_GAME_RANKING_MORE_TABLE_TITLE_MAP: Record<string, string[]> = {
  wechat_popularity: ['wechat_popularity|game_rank', 'wechat_popularity|avg_rank_30d'],
  wechat_bestseller: ['wechat_bestseller|game_rank', 'wechat_bestseller|avg_rank_30d'],
  wechat_most_played: ['wechat_most_played|game_rank', 'wechat_most_played|avg_rank_30d'],
  douyin_popularity: ['douyin_popularity|game_rank', 'douyin_popularity|avg_rank_30d'],
  douyin_bestseller: ['douyin_bestseller|game_rank', 'douyin_bestseller|avg_rank_30d'],
  douyin_fresh_game: ['douyin_fresh_game|game_rank', 'douyin_fresh_game|avg_rank_30d'],
};
export const MINI_GAME_RANKING_MORE_TABLE_TITLE_MAP_DOUYIN: Record<string, string[]> = {
  douyin_popularity: ['douyin_popularity|game_rank', 'douyin_popularity|avg_rank_30d'],
  douyin_bestseller: ['douyin_bestseller|game_rank', 'douyin_bestseller|avg_rank_30d'],
  douyin_fresh_game: ['douyin_fresh_game|game_rank', 'douyin_fresh_game|avg_rank_30d'],
};

export const MINI_GAME_GENRE_SOURCE = 'wechat_minigame';
export const MINI_GAME_SOURCE = 'wechat';
export const MINI_GAME_ENTITY_TYPE = 'minigame';

// 游戏详情页路由path前缀
export const MINI_GAME_DETAIL_PAGE_PATH = '/intelligence/casualGamesHub/casualMiniGameRankings/gamesDetails';
